import client from "../client";
import { AssetInterface } from "../../models/AssetModel/Asset";
import { DataSelectType } from "../../models/DataSelectType";

class AssetService {
  async GetAll(page: number, pageSize: number, filters?: DataSelectType[]) {
    try {
      let url = `/api/Assets/Get`;
      let form: any = {
        page,
        pageSize,
      };

      if (filters && filters.length > 0) {
        filters.map(
          (item) =>
            (form[item.field === "YearId" ? "Year" : item.field] = item.value)
        );
      }

      const { data } = await client.post<AssetInterface[]>(url, form);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/assets/getbyid/${id}`;

      const { data } = await client.get<AssetInterface>(url);

      return data;
    } catch (error) {
      throw error;
    }
  }

  async Save(customer: AssetInterface) {
    try {
      let url = `/api/Assets`;

      const { data } = await client.post<AssetInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetInterface) {
    try {
      let url = `/api/Assets/update/${id}`;

      const { data } = await client.post<AssetInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/Assets/remove/${id}`;
      await client.post<AssetInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetByTitleCompLocCustomer(
    page: number,
    pageSize: number,
    searchTerm: string,
    companyId: string | undefined,
    locationId: string | undefined,
    customerId: string | undefined
  ): Promise<AssetInterface[]> {
    try {
      let url = `/api/Assets/get`;

      let result = {
        title: searchTerm,
        page,
        pageSize,
        companyId,
        locationId: locationId ? locationId : null,
        customerId: customerId ? customerId : null,
      };

      // if (!companyId || !locationId || !customerId) {
      if (!companyId) {
        return [];
      } else {
        const { data } = await client.post<AssetInterface[]>(url, result);
        return data;
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetService();
